<template>
  <gd-login :callback="callback" class="bg-dark"></gd-login>
</template>

<script>
import GdLogin from '@groovepages/gd-ui-kit/components/Login';
import store from '@/state';

export default {
  layout: 'basic',
  components: {
    GdLogin
  },
  data() {
    return {
      callback: user => {
        let self = this;
        store.commit('login', user);
        self.$router.push({ name: 'dashboard' });
      }
    };
  }
};
</script>
